import { BaseModel, registerModel } from '~/shared/model'
import { isBoolean, isString, isUnknownObject } from '~/shared/utils/guards'
import UnifiedProfilePersonal from './UnifiedProfilePersonal'
import UnifiedProfileEducation from './UnifiedProfileEducation'
import UnifiedProfileCareerGoal from './UnifiedProfileCareerGoal'
import UnifiedProfileExperience from './UnifiedProfileExperience'
import UnifiedProfileAbout from './UnifiedProfileAbout'
import UnifiedProfileSkill from './UnifiedProfileSkill'
import UnifiedProfileLanguage from './UnifiedProfileLanguage'
import UnifiedProfilePublishing from './UnifiedProfilePublishing'

export default class UnifiedProfile extends BaseModel {
  static override constructorName = 'UnifiedProfileModel'

  uuid: string = ''
  'is_resume_disabled': boolean = false
  personal: UnifiedProfilePersonal = new UnifiedProfilePersonal()
  education: UnifiedProfileEducation = new UnifiedProfileEducation()
  'career_goal': UnifiedProfileCareerGoal = new UnifiedProfileCareerGoal()
  experience: UnifiedProfileExperience = new UnifiedProfileExperience()
  about: UnifiedProfileAbout = new UnifiedProfileAbout()
  skills: UnifiedProfileSkill[] = []
  languages: UnifiedProfileLanguage[] = []
  publishing: UnifiedProfilePublishing = new UnifiedProfilePublishing()

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.uuid = isString(data.uuid) ? data.uuid : ''
      this.is_resume_disabled = isBoolean(data.is_resume_disabled) ? data.is_resume_disabled : false
      this.personal = new UnifiedProfilePersonal(data.personal)
      this.education = new UnifiedProfileEducation(data.education)
      this.career_goal = new UnifiedProfileCareerGoal(data.career_goal)
      this.experience = new UnifiedProfileExperience(data.experience)
      this.about = new UnifiedProfileAbout(data.about)
      this.skills = Array.isArray(data.skills)
        ? data.skills.map(item => new UnifiedProfileSkill(item))
        : []
      this.languages = Array.isArray(data.languages)
        ? data.languages.map(item => new UnifiedProfileLanguage(item))
        : []
      this.publishing = new UnifiedProfilePublishing(data.publishing)
    }
  }
}

registerModel(UnifiedProfile)
